import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { tap } from 'rxjs';
import { Setor } from 'src/app/models/setor';
import { ScaleInUseService } from 'src/app/services/scale-in-use.service';

@Component({
  selector: 'app-block-sector',
  templateUrl: './block-sector.component.html',
  styleUrls: ['./block-sector.component.scss'],
})
export class BlockSectorComponent implements OnInit {

  @Output() setoresSelected = new EventEmitter<number[]>();
  @Input() setores!: Setor[];

  constructor(
    private alertCtrl: AlertController,
    private scaleInUse: ScaleInUseService
  ) { }

  ngOnInit() {

  }

  async openBlockSector() {
    console.log(this.setores);
    const alert = await this.alertCtrl.create({
      header: 'Selecione os setores para bloquear',
      inputs: this.setores.map(s => {
        return {
          name: s.nome,
          type: 'checkbox',
          label: s.nome,
          value: s.id
        }
      }),
      buttons: [{
        text: 'Cancelar',
        role: 'cancel',
        handler: () => {
          console.log('Cancelou');
        }
      }, {
        text: 'Ok',
        handler: (setoresIds: number[]) => {
          console.log(setoresIds);
          if (setoresIds && setoresIds.length > 0) {
            this.setoresSelected.emit(setoresIds);
          }
        }
      }]
    });

    await alert.present();
  }
}
